<template>
    <div class="component__Vehicle--Search">
        <div v-if="mode == 1">
            <div
                class="image--car"
                :class="!strema ? 'image--car--margins' : ''"
            >
                <div
                    class="info-car-notes d-flex float-right mr-2"
                    v-if="getAllNotes().length > 0 && !strema"
                >
                    <v-btn
                        v-if="checkPermissions()"
                        color="red"
                        icon
                        @click="onClickNotesIcon"
                    >
                        <svg
                            id="svgIconAlerts"
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                        >
                            <g transform="translate(-226.495 -112.495)">
                                <circle
                                    cx="14"
                                    cy="14"
                                    r="14"
                                    transform="translate(226.495 112.495)"
                                    :fill="
                                        carNotes.hasValidNotes
                                            ? '#d90b3b'
                                            : '#0453A5'
                                    "
                                />
                                <path
                                    d="M17.774,15.98H-.95a.224.224,0,0,1-.2-.113.207.207,0,0,1,0-.211L8.217.108a.23.23,0,0,1,.39,0l9.363,15.548a.207.207,0,0,1,0,.211A.224.224,0,0,1,17.774,15.98ZM8.5,13a.5.5,0,1,0,.5.5A.5.5,0,0,0,8.5,13Zm0-8.385a.5.5,0,0,0-.5.5v5a.5.5,0,1,0,1,0v-5A.5.5,0,0,0,8.5,4.615Z"
                                    transform="translate(232.495 116.495)"
                                    fill="#fff"
                                    stroke="rgba(255,255,255,0)"
                                    stroke-miterlimit="10"
                                    stroke-width="1"
                                />
                            </g>
                        </svg>
                    </v-btn>
                </div>
                <div v-if="!strema" class="container__image--car">
                    <img
                        :src="photoVehicle"
                        class="img-fluid"
                        alt
                        :style="isPhotoDefault ? 'transform: scaleX(-1)' : ''"
                    />
                </div>

                <search-by-plate-component
                    :key="key"
                    :country="countrySelected"
                    :plate="plate"
                    @on-plate-changed="onPlateChanged"
                    @on-country-changed="onCountryChanged"
                    @on-plate-searched="
                        ({ plate, dataSourceId }) =>
                            searchVehicle({
                                plate,
                                dataSourceId,
                            })
                    "
                    @on-plate-cleared="onPlateCleared"
                    :strema="strema"
                    :showClear="showClear"
                    @on-history-plate-selected="
                        (info) => loadVehicle(info, false)
                    "
                />
            </div>

            <details-component v-if="!strema" />

            <div
                v-if="!strema"
                class="search__model--brand"
                @click="onClickVehicleSearchRouterLink"
            >
                <router-link :to="{ name: 'vehicle_Search' }">
                    {{ $t("search-by-brand-and-model") }}
                </router-link>
            </div>
        </div>

        <div v-if="mode == 3">
            <search-by-plate-component
                :key="key"
                :country="countrySelected"
                :plate="plate"
                @on-plate-changed="onPlateChanged"
                @on-country-changed="onCountryChanged"
                @on-plate-searched="
                    ({ plate, dataSourceId }) =>
                        searchVehicle({
                            plate,
                            dataSourceId,
                        })
                "
                @on-plate-cleared="onPlateCleared"
                :strema="false"
                :showClear="showClear"
                @on-history-plate-selected="(info) => loadVehicle(info, false)"
                :showHistoryButton="false"
            />
        </div>

        <!-- Modal -->
        <v-dialog :persistent="true" v-model="modal.show" max-width="500px">
            <v-card class="modal--tips4y">
                <v-card-title>
                    <span>{{ modal.title }}</span>
                </v-card-title>

                <v-card-text>
                    <span>{{ modal.message }}</span>
                </v-card-text>

                <v-card-actions class="align__flex--right">
                    <v-btn
                        class="primary-button"
                        text
                        @click="modal.show = false"
                    >
                        <span style="text-transform: capitalize">{{
                            $t("backoffice.actions.close")
                        }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal -->

        <!-- Modal Ktype -->
        <v-dialog
            :persistent="true"
            v-model="modalKtype.show"
            max-width="500px"
        >
            <v-card class="modal--tips4y">
                <v-card-title>
                    <span>{{ modalKtype.title }}</span>
                </v-card-title>

                <v-card-text>
                    <span>{{ modalKtype.message }}</span>
                    <div
                        class="ml-3 mb-3"
                        v-for="(item, index) in arrayKtypes"
                        :key="index"
                    >
                        <base-radio-button
                            v-model="radiosKtypes"
                            :value="item.Ktype"
                        >
                            <span>
                                {{ item.Make }} {{ item.Model }}
                                {{ item.Version }} ({{ item.Power_CV }} CV)
                                {{ item.Drive }}
                            </span>
                        </base-radio-button>
                    </div>
                </v-card-text>

                <v-card-actions class="align__flex--center">
                    <v-btn
                        color="primary"
                        text
                        @click="() => clickModalKtype()"
                        :disabled="radiosKtypes == ''"
                    >
                        {{ $t("backoffice.actions.ok") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal -->

        <!-- Modal -->
        <v-dialog
            v-model="modalNotes.show"
            max-width="600px"
            @watch-show-value="clickOutside"
        >
            <v-card class="modal--tips4y text-justify p-4">
                <div class="d-flex justify-center">
                    <div class="icon-close" @click="clickOutside(false)">
                        <img
                            src="/images/_SVGs/environmental/fechar.svg"
                            onload="SVGInject(this)"
                            width="20"
                            height="20"
                        />
                    </div>
                </div>
                <p class="ml-6 mb-2" style="color: #4b4849; font-size: 20px">
                    {{ $t("backoffice.templates.tecnical-msgs") }}
                </p>
                <p class="ml-6 mb-7" style="color: #9e9d9d; font-size: 14px">
                    {{ vehicleInformation }}
                </p>

                <v-card-text v-for="note in getValidNotes()" :key="note.infoId">
                    <span style="color: #9e9d9d; font-size: 12px"
                        >{{ note.validFrom | formatOnlyDate }} -
                    </span>
                    <span style="color: #9e9d9d; font-size: 12px">{{
                        note.validTo | formatOnlyDate
                    }}</span>
                    <p
                        style="
                            color: #4b4849;
                            font-size: 16px;
                            font-weight: bold;
                        "
                    >
                        {{ note.headline }}
                    </p>
                    <p
                        :class="note.seeMore ? '' : 'text-truncate'"
                        style="color: #4b4849; font-size: 14px"
                    >
                        {{ note.text }}
                    </p>
                    <button
                        style="color: #00bce7; outline: none"
                        @click="note.seeMore = !note.seeMore"
                    >
                        <span style="text-transform: capitalize">{{
                            note.seeMore ? $t("read-less") : $t("read-more")
                        }}</span>
                    </button>
                    <hr />
                </v-card-text>

                <div
                    v-if="getAllNotes().length > 1"
                    class="text-center justify-center"
                >
                    <v-btn color="#00BCE7" text @click="onSeeNotesClicked">
                        <span style="text-transform: capitalize">{{
                            $t("backoffice.templates.see-history")
                        }}</span>
                    </v-btn>
                </div>
                <div v-else class="text-center justify-center">
                    <v-btn color="#00BCE7" text @click="clickOutside(false)">
                        <span style="text-transform: capitalize">{{
                            $t("ok")
                        }}</span>
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- Modal -->

        <base-modal
            v-model="modalAlertToLeave.show"
            :title="$t('backoffice.general.warning')"
            modal-width="400px"
            :persistent="true"
            class="test11"
        >
            <template v-slot:modal-close>
                <div @click="closeModalAlertToLeave">
                    <img
                        src="/images/_SVGs/environmental/fechar.svg"
                        onload="SVGInject(this)"
                        width="20"
                        height="20"
                    />
                </div>
            </template>

            <template v-slot:modal-body>
                {{ $t("backoffice.templates.messages.finish-quotation") }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button" @click="onDontSaveBudget">
                        <span style="text-transform: capitalize">{{
                            $t("backoffice.actions.cancel")
                        }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="onSaveBudget">
                        <span style="text-transform: capitalize">{{
                            $t("backoffice.actions.finalize")
                        }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal-->
        <v-dialog
            content-class="vehicle-search-modal-card"
            v-if="mode == 2"
            v-model="show"
            max-width="600px"
            :persistent="true"
        >
            <v-card>
                <v-tabs
                    v-model="tabs"
                    slider-color="#9E9D9D"
                    ref="tab_reference"
                >
                    <v-tab style="color: black">
                        {{ $t("tab1-vehicle-search-modal") }}
                    </v-tab>
                    <v-tab style="color: black">
                        {{ $t("tab2-vehicle-search-modal") }}
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tabs">
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text class="d-flex justify-center">
                                <div
                                    class="component__Vehicle--Search dialog-alignment"
                                    style="width: 50%"
                                >
                                    <p class="title m-0 p-0">
                                        {{ $t("search-by-plate") }}
                                    </p>
                                    <p class="subtitle">
                                        {{
                                            $t("subtitle1-vehicle-search-modal")
                                        }}
                                    </p>
                                    <div style="width: 80%">
                                        <search-by-plate-component
                                            :key="key"
                                            :country="countrySelected"
                                            :plate="plate"
                                            @on-plate-changed="onPlateChanged"
                                            @on-country-changed="
                                                onCountryChanged
                                            "
                                            @on-plate-searched="
                                                ({ plate, dataSourceId }) =>
                                                    searchVehicle({
                                                        plate,
                                                        dataSourceId,
                                                    })
                                            "
                                            @on-history-plate-selected="
                                                (info) =>
                                                    loadVehicle(info, false)
                                            "
                                            @on-plate-cleared="onPlateCleared"
                                            :showHistoryButton="false"
                                        />
                                    </div>
                                    <div class="search__model--brand mt-3">
                                        <span @click="searchByModelClicked">
                                            {{
                                                $t("search-by-brand-and-model")
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text class="d-flex justify-center">
                                <div
                                    class="component__Vehicle--Search dialog-alignment"
                                >
                                    <p class="title m-0 p-0">
                                        {{ $t("search-by-brand-and-model") }}
                                    </p>
                                    <p class="">
                                        {{
                                            $t("subtitle2-vehicle-search-modal")
                                        }}
                                    </p>
                                    <div>
                                        <search-by-make-component
                                            :dialog="true"
                                            :redirectAfterSearch="false"
                                            @vehicle-searched="closeModal"
                                        />
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>

                <div
                    class="div-btn"
                    style="text-align: center; padding-bottom: 14px"
                >
                    <v-btn
                        text
                        @click="() => closeModal(true)"
                        class="danger-button"
                    >
                        <span style="text-transform: capitalize">{{
                            $t("cancel")
                        }}</span>
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- Modal -->
    </div>
</template>

<script>
import mixinVehicleIdentification from "@mixins/b2b/vehicleIdentification";
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import BaseRadioButton from "@components/shared/widgets/BaseRadioButton.vue";

export default {
    components: {BaseRadioButton, BaseModal},
    mixins: [mixinVehicleIdentification],
    props: {
        mode: {
            type: Number,
            default: 1,
            required: true,
        },
        strema: {
            type: Boolean,
            default: false,
            required: false,
        },
        initPlate: {
            type: String,
            default: "",
            required: false,
        },
        initCountry: {
            type: String,
            default: "",
            required: false,
        },
        showClear: {
            type: Boolean,
            default: false,
            required: false,
        },
        show: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
.dialog-alignment {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.component__Vehicle--Search {
    .info-car-notes {
        position: absolute;
        z-index: 1;
        left: 86%;
        top: -30px;
    }

    .image--car--margins {
        margin: 30px 15px 10px;
    }

    .image--car {
        position: relative;

        .container__image--car {
            text-align: center;
            margin: 0;
            transform: scaleX(-1);

            img {
                margin: 0;
            }
        }

        .vehicle--search--minheight {
            height: 40px;
        }

        .vehicle--search--fullheight {
            height: 56px;
        }

        .vehicle--search {
            display: flex;

            .plate--country {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 100%;
                font-size: 20px;
                font-weight: 500;
                color: #ffffff;
                background: var(--v-primary-base);
                border: 0;
                border-top-left-radius: 7px;
                border-bottom-left-radius: 7px;

                .select-countries-plate {
                    width: 40px;
                    height: 100%;
                    font-size: 20px;
                    font-weight: 500;
                    color: #ffffff;
                    background: var(--v-primary-base);
                    border: 0;
                    border-top-left-radius: 7px;
                    border-bottom-left-radius: 7px;
                    text-align: center;
                    outline: none;

                    .v-input__control {
                        height: 100%;
                        min-height: 100%;
                        .v-input__slot {
                            height: 100%;
                            padding: 0px !important;
                            box-shadow: none !important;
                            background: transparent !important;

                            .v-select__selections {
                                position: absolute !important;
                                left: 35%;
                                color: #fff;
                            }

                            .v-input__append-inner {
                                display: none !important;
                            }
                        }
                    }
                }
            }

            .box__vehicle--search--minwidth {
                width: calc(100% - 58px);
                input {
                    border-radius: 0 !important;
                }
            }

            .box__vehicle--search--fullwidth {
                width: calc(100%);
                input {
                    border-top-right-radius: 7px;
                    border-bottom-right-radius: 7px;
                }
            }

            .box__vehicle--search {
                position: relative;

                input {
                    width: 100%;
                    height: 100%;
                    background-color: $grey-light;
                    font-size: 20px;
                    font-weight: 500;
                    letter-spacing: 1px;
                    color: var(--v-primary-base);
                    text-transform: uppercase;
                    border: 0;
                    padding: 8px 40px 8px 8px;
                    margin: 0;
                    outline: none !important;

                    &::placeholder {
                        color: $grey-medium;
                    }
                    &::-webkit-input-placeholder {
                        color: $grey-medium;
                    }
                    &:-moz-placeholder {
                        color: $grey-medium;
                    }
                    &::-moz-placeholder {
                        color: $grey-medium;
                    }
                    &:-ms-input-placeholder {
                        color: $grey-medium;
                    }

                }

                .btn-icon-search {
                    border-top-right-radius: 7px;
                    border-bottom-right-radius: 7px;
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: 0;
                    right: 0;
                    width: 40px;
                    height: 100%;
                    cursor: pointer;
                    path,
                    g {
                        stroke: var(--v-primary-base);
                    }
                    svg {
                        color: var(--v-primary-base);
                    }
                }
            }

            .btn-open-history {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 100%;
                font-size: 20px;
                font-weight: 700;
                color: $white;
                background: var(--v-primary-base);
                border: 0;
                padding: 0;
                margin: 0;
                border-radius: 7px;
                margin-left: 8px;
                cursor: pointer;
                transition: all 0.2s ease-in-out;

                &:hover {
                    background-color: var(--v-primary-lighten5);

                    svg {
                        rect,
                        path:last-child {
                            fill: var(--v-primary-base);
                        }
                    }
                }
            }
        }
    }

    .search__model--brand {
        text-align: center;
        margin: 0;

        cursor: pointer;

        a {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0.24px;
            color: $grey;
            text-decoration: none;
            transition: color 0.4s;

            &:hover {
                color: var(--v-primary-base);
            }
        }
    }

    .photo_default {
        transform: scaleX(-1) !important;
    }
}
.icon-close {
    position: absolute;
    top: 5px;
    right: 15px;
    cursor: pointer;
    z-index: 99999;
}

.vehicle-search-modal-card {
    overflow-y: inherit !important;

    .v-card.v-sheet.theme--light {
        border-radius: 25px !important;
    }

    .v-window.v-item-group.theme--light.v-tabs-items {
        overflow: inherit !important;
    }
}
</style>
